import { gql } from '@apollo/client';

export const A2pPhonesQuery = gql`
  query TcrPhones($campaignId: String!) {
    tcrPhones(campaignId: $campaignId) {
      phoneNumber
      campaignId
      tmobileNumberMappingStatus
      nonTmobileNumberMappingStatus
      errors
      createdAt
      updatedAt
    }
  }
`;

export const A2pPhoneQuery = gql`
  query TcrPhone($phoneNumber: String!) {
    tcrPhone(phoneNumber: $phoneNumber) {
      phoneNumber
      campaignId
      tmobileNumberMappingStatus
      nonTmobileNumberMappingStatus
      errors
      createdAt
      updatedAt
    }
  }
`;

export const A2pPhoneTaskStatusQuery = gql`
  query TaskStatus($taskId: String!) {
    tcrTaskStatus(taskId: $taskId) {
      phoneNumber
      status
    }
  }
`;

export const A2pAssignCampaignMutation = gql`
  mutation AssignCampaign($campaignId: String!, $tcrCampaignId: String!) {
    assignCampaign(campaignId: $campaignId, tcrCampaignId: $tcrCampaignId) {
      taskId
    }
  }
`;
